<div class="container mt-5">
  <h2 class="text-center mb-4">{{ translationService.getTranslation('Exam Page') }}</h2>

    <div class="row mb-3">
      <label class="col-md-3 col-form-label">
        {{ translationService.getTranslation('Exam Attendance Number') }}:
      </label>
      <div class="col-md-9 d-flex gap-2" dir="ltr">
        <input type="text" maxlength="2" class="form-control text-center" style="text-transform: uppercase;"
              [(ngModel)]="part1" (ngModelChange)="part1 = part1?.toUpperCase()"
              (input)="autoMove($event, part2Ref)" (paste)="handlePaste($event)" #part1Ref>

        <span>-</span>
        <input type="text" maxlength="4" class="form-control text-center" style="text-transform: uppercase;"
              [(ngModel)]="part2" (ngModelChange)="part2 = part2?.toUpperCase()"
              (input)="autoMove($event, part3Ref)" (keydown.backspace)="autoBackspace($event, part1Ref)" #part2Ref>

        <input type="text" maxlength="4" class="form-control text-center" style="text-transform: uppercase;"
              [(ngModel)]="part3" (ngModelChange)="part3 = part3?.toUpperCase()"
              (input)="autoMove($event, part4Ref)" (keydown.backspace)="autoBackspace($event, part2Ref)" #part3Ref>

        <input type="text" maxlength="4" class="form-control text-center" style="text-transform: uppercase;"
              [(ngModel)]="part4" (ngModelChange)="part4 = part4?.toUpperCase()"
              (keydown.backspace)="autoBackspace($event, part3Ref)" #part4Ref>
      </div>
    </div>

  <div class="row mb-3">
    <label for="examLanguage" class="col-md-3 col-form-label">
      {{ translationService.getTranslation('Choose Language For Exam') }}:
    </label>
    <div class="col-md-9">
      <select id="examLanguage" class="form-select" [(ngModel)]="LanguageID" (change)="onLanguageChange()">
        <option value="0" disabled>{{ translationService.getTranslation('Select a language') }}</option>
        <option *ngFor="let lang of filteredLanguagesList; let i = index" [value]="i + 1">
          {{ lang.LanguageName }}
        </option>
      </select>
    </div>
  </div>

  
  <div *ngIf="showAlert" class="alert alert-danger">{{ errorMessage }}</div>

  <div class="row">
    <div class="col-md-12 text-center">
      <button class="btn btn-lg btn-success px-5" [disabled]="!(ExamAttendanceNo?.length >= 8 && LanguageID != 0)" (click)="startExam()">
        {{ translationService.getTranslation('Start Exam') }}
      </button>
    </div>
  </div>

  <div *ngIf="nonDisclosureAgreementModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered" style="table-layout: fixed; width: 100%;">
            <tbody>
              <tr>
                <td class="bg-success text-light fs-4 text-center fw-bold">عربي</td>
                <td class="bg-success text-light fs-4 text-center fw-bold">English</td>
              </tr>
              <tr>

                <td dir="rtl">
                  <h6 class="text-center"><u>إقرار مقدم الطلب واتفاقية عدم الإفشاء</u></h6>
                  <h6 class="text-center">أقر بأنني:</h6>
                  <ul>
                    <li>أدرك تماما متطلبات الشهادة الخاصة بي.</li>
                    <li>تلقيت جميع المعلومات بخصوص شهادتي. </li>
                    <li>جميع الوثائق التي قدمتها سليمة وسارية وجميع المعلومات المشتركة معكم صحيحة. </li>
                    <li>أفهم، أتفق، وسوف أتبع كل قواعد الامتحانات، والسياسات التنظيمية وقواعد السلوك. </li>
                    <li>لن أسيئ استخدام الشهادة أو أي إشعارات خاصة بمركز الاختبار. </li>
                  </ul>
                </td>

                <td dir="ltr">
                  <h6 class="text-center"><u>Applicant Declaration and Non-Disclosure Agreement</u></h6>
                  <h6 class="text-center">I hereby declare as follows:</h6>
                  <ul>
                    <li>I am fully aware of the requirements necessary for my certification.</li>
                    <li>I have received all the information pertaining to my certificate. </li>
                    <li>All the prerequisite documents I have submitted are valid, and all the information I have shared with you is true. </li>
                    <li>I understand, agree to, and will adhere to all examination rules, regulations, policies, and the code of conduct. </li>
                    <li>I will not misuse the certificate, logo, or any associated marks. </li>
                  </ul>
                </td>

              </tr>
              <tr>
                <td class="bg-success text-light fs-4 text-center fw-bold">Urdu</td>
                <td class="bg-success text-light fs-4 text-center fw-bold">Hindi (हिन्दी)</td>
              </tr>
              <tr>

                <td dir="rtl">
                  <h6 class="text-center"><u>درخواست گزار کا اعلان اور غیر افشاء کا معاہدہ </u></h6>
                  <h6 class="text-center">میں یہاں درج ذیل کے طور پر اعلان کرتا/کرتی ہوں:</h6>
                  <ul>
                    <li>مجھے اپنی سند کے لیے ضروری تقاضوں کا مکمل علم ہے۔ </li>
                    <li>میں نے اپنی سند سے متعلق تمام معلومات حاصل کر لی ہیں۔  </li>
                    <li>میں نے جو تمام پیشگی دستاویزات جمع کرائی ہیں وہ درست ہیں، اور میں نے جو بھی معلومات آپ کے ساتھ شیئر کی ہیں وہ سچ ہیں۔ </li>
                    <li>میں امتحان کے تمام قواعد، ضوابط، پالیسیوں اور ضابطہ اخلاق کو سمجھتا/سمجھتی ہوں، ان سے اتفاق کرتا/کرتی ہوں اور ان کی پابندی کروں گا/گی۔ </li>
                    <li>میں اس سند، لوگو، اور متعلقہ نشانات کا غلط استعمال نہیں کروں گا/گی۔  </li>
                  </ul>
                </td>

                <td dir="ltr">
                  <h6 class="text-center"><u>आवेदक घोषणा और गैर-प्रकटीकरण समझौता </u></h6>
                  <h6 class="text-center">मैं निम्नलिखित के रूप में घोषणा करता/करती हूँ: </h6>
                  <ul>
                    <li>मैं अपनी प्रमाणन आवश्यकताओं के बारे में पूरी तरह से अवगत हूँ। </li>
                    <li>मैंने अपने प्रमाणपत्र से संबंधित सभी जानकारी प्राप्त कर ली है।  </li>
                    <li>मैंने जो भी पूर्वापेक्षित दस्तावेज़ जमा किए हैं वे मान्य हैं, और मैंने आपके साथ जो भी जानकारी साझा की है वह सच्ची है।  </li>
                    <li>मैं सभी परीक्षा नियमों, विनियमों, नीतियों और आचार संहिता को समझता/समझती हूँ, उनसे सहमत हूँ और उनका पालन करूँगा/गी। </li>
                    <li>मैं इस प्रमाणपत्र, लोगो, और किसी भी संबंधित निशान का दुरुपयोग नहीं करूँगा </li>
                  </ul>
                </td>

              </tr>
              <tr>
                <td class="bg-success text-light fs-4 text-center fw-bold">Bengali (বাংলা) </td>
                <td class="bg-success text-light fs-4 text-center fw-bold">Turkish (Türkçe) </td>
              </tr>
              <tr>
                <td dir="ltr">
                  <h6 class="text-center"><u>আবেদনকারী ঘোষণা এবং গোপনীয়তা চুক্তি </u></h6>
                  <h6 class="text-center">আমি নিম্নলিখিতগুলি ঘোষণা করছি: </h6>
                  <ul>
                    <li>আমি আমার সার্টিফিকেশনের জন্য প্রয়োজনীয় প্রয়োজনীয়তার সম্পর্কে সম্পূর্ণ সচেতন।.</li>
                    <li>আমি আমার সার্টিফিকেট সম্পর্কিত সমস্ত তথ্য পেয়েছি। </li>
                    <li>আমি যে সমস্ত প্রয়োজনীয় নথি জমা দিয়েছি সেগুলি বৈধ, এবং আমি আপনার সাথে যে সমস্ত তথ্য শেয়ার করেছি তা সত্য।  </li>
                    <li>আমি সমস্ত পরীক্ষা নিয়ম, বিধি, নীতি এবং আচরণবিধি বুঝি, একমত এবং মেনে চলব।  </li>
                    <li>আমি এই সার্টিফিকেট, লোগো, এবং কোনও সম্পর্কিত চিহ্নের অপব্যবহার করব না।  </li>
                  </ul>
                </td>

                <td dir="ltr">
                  <h6 class="text-center"><u>Başvuru sahibinin beyanı ve gizlilik anlaşması,  </u></h6>
                  <h6 class="text-center">Aşağıda belirtileni Kabul ediyorum: </h6>
                  <ul>
                    <li>Sertifikasyon gereksinimlerimin tamamen farkındayım. </li>
                    <li>Sertifikamla ilgili tüm bilgileri aldım.  </li>
                    <li>Sunduğum tüm ön koşul belgeleri geçerlidir ve sizinle paylaştığım tüm bilgiler doğrudur.  </li>
                    <li>Tüm sınav kurallarına, düzenlemelere, politikalara ve davranış kurallarına uyacağımı anlıyor, kabul ediyor ve bunlara uyacağım.  </li>
                    <li>Sertifikayı, logoyu ve ilgili işaretleri kötüye kullanmayacağım.  </li>
                  </ul>
                </td>


              </tr>
              <tr>
                <td class="bg-success text-light fs-4 text-center fw-bold">Indonesian (Bahasa Indonesia)  </td>
                <td class="bg-success text-light fs-4 text-center fw-bold">Tamil (தமிழ்)  </td>
              </tr>
              <tr>
                <td dir="ltr">
                  <h6 class="text-center"><u>Deklarasi Pelamar dan Perjanjian Kerahasiaan  </u></h6>
                  <h6 class="text-center">Saya dengan ini menyatakan sebagai berikut:  </h6>
                  <ul>
                    <li>Saya sepenuhnya menyadari persyaratan yang diperlukan untuk sertifikasi saya.  </li>
                    <li>Saya telah menerima semua informasi yang berkaitan dengan sertifikat saya.   </li>
                    <li>Semua dokumen prasyarat yang saya kirimkan valid, dan semua informasi yang saya bagikan dengan Anda adalah benar.  </li>
                    <li>Saya memahami, menyetujui, dan akan mematuhi semua aturan ujian, regulasi, kebijakan, dan kode etik.  </li>
                    <li>Saya tidak akan menyalahgunakan sertifikat, logo, dan tanda terkait.   </li>
                  </ul>
                </td>
                <td dir="ltr">
                  <h6><u>விண்ணப்பதாரர் அறிவிப்பு மற்றும் மறைவைப்புக் காப்பு ஒப்பந்தம்  </u></h6>
                  <h6>நான் பின்வரும் விஷயங்களை அறிவிக்கிறேன்:  </h6>
                  <ul>
                    <li>எனது சான்றிதழுக்குத் தேவையான தேவைகள் குறித்து நான் முழுமையாகக் கல்வி கற்றிருக்கிறேன்.  </li>
                    <li>எனது சான்றிதழுக்கான அனைத்து தகவல்களையும் பெற்றுள்ளேன்.  </li>
                    <li>நான் சமர்ப்பித்த அனைத்து முன் ஆதாரக் கோப்புகளும் சரியானவை, மற்றும் உங்களுடன் பகிர்ந்த அனைத்து தகவல்களும் உண்மையானவை.   </li>
                    <li>நான் அனைத்து தேர்வு விதிகள், ஒழுங்குகள், கொள்கைகள் மற்றும் நடத்தை விதிமுறைகளைப் புரிந்துகொண்டு, ஒப்புக்கொண்டு, அதைப் பின்பற்றுவேன்.  </li>
                    <li>இந்த சான்றிதழ், லோகோ மற்றும் தொடர்புடைய குறிகளை தவறாக பயன்படுத்தமாட்டேன்.  </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-outline-secondary" (click)="agreeDisclosureAgreement()">
            <i class="bi bi-check-circle-fill"></i> {{ translationService.getTranslation('Agree') }}
          </button>
        </div>        
      </div>
    </div>
  </div>

</div>
